import axios from "../config/axios"


export const SessionUMRepository = {
  getUserSessions: () => {
    return axios.get(`/api/session/user/all`);
  },

}